import $ from 'jquery'
import store from 'base/store'
import Event from 'base/event'
import Hub from 'base/hub'

export default function setupAttentive() {
  if (!store.getState().appConfig.isProductionLike) {
    return
  }

  window.attentive_onModalOpen = metadata => Hub.pub(Event.Attentive.MODAL_VIEW, metadata)

  window.attentive_onModalClose = metadata => Hub.pub(Event.Attentive.MODAL_CLOSED, metadata)

  window.attentive_onSmsEnter = metadata => Hub.pub(Event.Attentive.SMS_ENTERED, metadata)

  $.getScript('//cdn.attn.tv/everlane/dtag.js')
}
